import React, { useEffect } from 'react';
import { Download, FileText } from 'lucide-react';
import SeoMeta from '../components/SeoMeta';
import PageHero from '../components/ui/PageHero';
import SectionHeader from '../components/ui/SectionHeader';
import './Documents.css';

// ⬇️ ИМПОРТ PDF
import presentationPdf from '../assets/presentation.pdf';
import requisitePdf from '../assets/requisite.pdf';
import soundPdf from '../assets/sound.pdf';
import profilPdf from '../assets/profil.pdf';
import seismikaPdf from '../assets/seismika.pdf';
import pbPdf from '../assets/pb.pdf';
import profil2Pdf from '../assets/profil2.pdf';
import modulPdf from '../assets/modul.pdf';
import zaklepkiPdf from '../assets/zaklepki.pdf';

const documents = [
  {
    title: 'Презентация компании',
    description:
      'Краткая информация о команде, направлениях и подходах к производству.',
    cta: 'Скачать презентацию',
    file: presentationPdf
  },
  {
    title: 'Реквизиты компании',
    description: 'Официальные данные для договоров и бухгалтерии.',
    cta: 'Скачать реквизиты',
    file: requisitePdf
  },
  {
    title: 'Расчет звукоизоляции и перегородок',
    description:
      'Методика расчетов звукоизоляции перегородок и конструкций с применяемыми материалами и техническими параметрами.',
    cta: 'Скачать расчет',
    file: soundPdf
  },
  {
    title: 'Сертификаты на профиль',
    description:
      'Сертификаты соответствия и качества на металлический профиль, используемый в конструкциях.',
    cta: 'Скачать сертификаты',
    file: profilPdf
  },
  {
    title: 'Сертификат сейсмостойкости',
    description:
      'Документы, подтверждающие соответствие конструкций требованиям сейсмической безопасности.',
    cta: 'Скачать сертификат',
    file: seismikaPdf
  },
  {
    title: 'Пожарный сертификат',
    description:
      'Сертификаты пожарной безопасности на применяемые материалы.',
    cta: 'Скачать сертификат',
    file: pbPdf
  },
  {
    title: 'Сертификаты соответствия на профили',
    description:
      'Официальные документы о соответствии профилей действующим техническим регламентам.',
    cta: 'Скачать документы',
    file: profil2Pdf
  },
  {
    title: 'Сертификаты соответствия на сборно-разборные здания',
    description:
      'Документация, подтверждающая соответствие сборно-разборных зданий нормативным требованиям.',
    cta: 'Скачать сертификаты',
    file: modulPdf
  },
  {
    title: 'Сертификаты на заклепки и крепеж',
    description:
      'Сертификаты качества и соответствия на заклепки и крепежные элементы.',
    cta: 'Скачать сертификаты',
    file: zaklepkiPdf
  }
];

const Documents = () => {
  const ogTitle = 'Документы и сертификаты LSTK Production';
  const ogDescription = 'Презентация компании, реквизиты и подтверждающие документы по материалам и сертификации ЛСТК.';

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="documents-page">
      <SeoMeta
        title={ogTitle}
        description={ogDescription}
        image="https://fk-alatau.kz/og/main.jpg"
      />
      <PageHero
        title="Документы"
        subtitle="Только главное: презентация компании и реквизиты"
        meta="Industrial Premium • Документы"
        image="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=2070"
      />

      <section className="documents-grid-section">
        <div className="container">
          <SectionHeader
            eyebrow="Документы"
            title="Ключевые материалы"
            subtitle="Минимум текста — максимум уверенности"
          />

          <div className="documents-grid">
            {documents.map((doc, index) => (
              <div key={index} className="document-card">
                <div className="document-icon-wrapper">
                  <FileText size={34} />
                </div>

                <div className="document-info">
                  <h3 className="h3">{doc.title}</h3>
                  <p className="body-md">{doc.description}</p>
                </div>

                {/* ⬇️ ВАЖНО: a + download */}
                <a
                  href={doc.file}
                  download
                  className="btn-primary download-btn"
                >
                  <Download size={18} />
                  {doc.cta}
                </a>
              </div>
            ))}
          </div>

          <p className="body-md documents-note">
            Все документы предоставляются по официальному запросу и используются
            для заключения договоров и подтверждения деятельности компании.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Documents;
